module.exports = __webpack_public_path__ + "img/map_2_click.880c580a.svg";